import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import MapsShowcase from "./components/MapsShowcase";
import Testimonials from "./components/Testimonials";
import GetTheApp from "./components/GetTheApp";
import FAQ from "./components/FAQ";
import ContactAndWaitlist from "./components/ContactAndWaitlist";
import TrustAndCTA from "./components/TrustAndCTA";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import { Toaster } from "./components/ui/toaster";
import { joinWaitlist, submitContact, trackDownload } from "./lib/api";

const handleSubscribe = async (email) => {
  return joinWaitlist(email);
};

const handleContact = async (payload) => {
  return submitContact(payload);
};

const handleTrackDownload = async (platform) => {
  return trackDownload(platform);
};

const Home = () => (
  <div className="App">
    <Navbar />
    <Hero onTrackDownload={handleTrackDownload} />
    <Features />
    <MapsShowcase />
    <Testimonials />
    <GetTheApp onTrackDownload={handleTrackDownload} />
    <TrustAndCTA />
    <FAQ />
    <ContactAndWaitlist onSubscribe={handleSubscribe} onContact={handleContact} />
    <Footer onTrackDownload={handleTrackDownload} />
    <ChatWidget />
    <Toaster />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
